import type {PolicyView} from '../../../../src/domain/policy/describe';
import {ApprovalLock,Fill,actionIcon,stopIcon} from './parts';

const scopes:Record<string,string>={invoice:'this invoice',customer:'every invoice for the customer'};

/** Each rule that stops or pauses reminders, with what it covers and how long it waits. */
export function StopRules({view}:{view:PolicyView}){
 const stops=view.pauses.filter(p=>p.effect==='Stop');const pauses=view.pauses.filter(p=>p.effect!=='Stop');
 const row=(p:PolicyView['pauses'][number])=><li key={p.id} className="pj-stop">
  <span className="pj-stop-icon" data-effect={p.effect}>{stopIcon(p.kind)}</span>
  <div><p><strong>{p.label}</strong></p>
   <p className="pj-stop-meta">{p.effect==='Stop'?'Stops':p.effect==='Pause'?'Pauses':p.effect} {scopes[p.scope]??p.scope}
    {p.detail?`, ${p.detail.replace(/^statuses /,'when ').replace(/except (\S+)/,'except the $1 step')}`:''}</p></div>
  {p.graceDays!==null&&<span className="pj-grace"><strong>{p.graceDays}</strong>
   {` ${p.graceBusiness?'business ':''}day${p.graceDays===1?'':'s'} grace`}</span>}
 </li>;
 return <section className="pj-panel" aria-labelledby="pj-stops-title">
  <h2 id="pj-stops-title">What stops reminders</h2>
  <p className="pj-lede">Alder checks these before every step.{view.pauses.some(p=>p.kind==='promise_active'&&p.graceDays)
   ?` A promise to pay holds reminders until ${view.cash.promiseGrace}.`:''}</p>
  <h3 className="pj-subhead">Pause</h3><ul className="pj-stops">{pauses.map(row)}</ul>
  <h3 className="pj-subhead">Stop for good</h3><ul className="pj-stops">{stops.map(row)}</ul>
 </section>;
}

/** Overpayment and refund paths as small step diagrams; other cash flows as on/off rows. */
export function CashFlows({view}:{view:PolicyView}){
 const flows=view.cash.flows;
 const main=flows.find(f=>f.id==='overpayment'&&f.enabled)??flows.find(f=>f.enabled&&f.timeline.length>1);
 const rest=flows.filter(f=>f!==main);
 return <section className="pj-panel" aria-labelledby="pj-cash-title">
  <h2 id="pj-cash-title">When money arrives</h2>
  {main&&<><h3 className="pj-subhead">{main.label}</h3>
   <p className="pj-lede">Starts when a customer pays more than they owe.{main.endsEarlyOn.length>0&&
    ` Ends early once the ${main.endsEarlyOn.map(e=>e.replace(/ (resolved|received|paid|closed)$/,' is $1')).join(' or ')}.`}</p>
   <ol className="pj-flow" aria-label={`${main.label} steps`}>{main.timeline.map(step=><li key={step.id}>
    <span className="pj-flow-day">{step.dayLabel}</span><span className="pj-flow-wait">{step.wait}</span>
    <ul>{step.actions.map((a,i)=><li key={i}>{actionIcon(a.kind)}<span><Fill text={a.title}/></span>
     <ApprovalLock approval={a.approval}/></li>)}</ul></li>)}</ol></>}
  {view.cash.refund&&<><h3 className="pj-subhead">Refunds</h3>
   <ol className="pj-flow pj-flow-quiet" aria-label="Refund steps">{view.cash.refund.map((s,i)=><li key={s}>
    <span className="pj-flow-day">Step {i+1}</span><ul><li><span>{s}</span></li></ul></li>)}</ol></>}
  {rest.length>0&&<><h3 className="pj-subhead">Other flows</h3><ul className="pj-other-flows">{rest.map(f=><li key={f.id}>
   <span>{f.label}</span><span className="pj-switch" data-on={f.enabled}>{f.enabled?'On':'Off'}</span></li>)}</ul></>}
 </section>;
}
